export default __webpack_public_path__ + "static/media/warning.030e1018.png";